import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { DriverStatus } from '../../../../../types';
import { INTL_FIELD_DRIVER_STATUS_ACTIVE, INTL_FIELD_DRIVER_STATUS_ARCHIVED } from '../../../schema';

interface DriverStatusProps {
    driverStatus: DriverStatus;
}

export const DriverStatusHint = (props: DriverStatusProps) => {
    const { driverStatus } = props;

    const labelClassNames = classNames(
        'label',
        'label-condensed',
        driverStatus === DriverStatus.ACTIVE ? 'label-primary' : 'label-muted'
    );

    return (
        <span className={labelClassNames}>
            <FormattedMessage
                id={
                    driverStatus === DriverStatus.ACTIVE
                        ? INTL_FIELD_DRIVER_STATUS_ACTIVE
                        : INTL_FIELD_DRIVER_STATUS_ARCHIVED
                }
            />
        </span>
    );
};
